import { Box, Button, Fade, Heading } from '@chakra-ui/react'
import { Icon } from 'components/atoms'
import { useAuthContext } from 'contexts/auth'
import { useState } from 'react'
import FormNewNotifications from './FormNotifications'
import NotificationList from './NotificationList'

const Notifications = () => {
    const [currentMode, setCurrentMode] = useState<'list' | 'form'>('list')
    const { isBackoffice } = useAuthContext()
    const isListMode = currentMode === 'list'

    return (
        <Box>
            <Fade in={isListMode}>
                {isListMode && (
                    <>
                        <Box display="flex" justifyContent="space-between">
                            <div></div>
                            {isBackoffice && (
                                <Button
                                    size="md"
                                    w={{ md: '200px', sm: 'full' }}
                                    colorScheme="primary"
                                    onClick={() => setCurrentMode('form')}
                                    rightIcon={<Icon name={'add'} />}
                                >
                                    Nova notificação
                                </Button>
                            )}
                        </Box>

                        <Heading marginTop={'16px'} size={'lg'}>
                            <Box maxW="4xl" mx="auto" p={4}>
                                <NotificationList />
                            </Box>
                        </Heading>
                    </>
                )}
            </Fade>

            <Fade in={!isListMode}>
                {!isListMode && (
                    <>
                        <Button
                            size="md"
                            colorScheme="primary"
                            onClick={() => setCurrentMode('list')}
                            display="flex"
                            justifyContent={'center'}
                            alignItems={'center'}
                        >
                            <Icon name={'arrow-left'} />
                        </Button>
                        <FormNewNotifications />
                    </>
                )}
            </Fade>
        </Box>
    )
}

export default Notifications
